import Vue from 'vue'
import { jsPDF } from 'jspdf'
import 'jspdf-autotable'
import utils from '@/mixins/utils.js'
import store from '@/store/store'
import { vue } from '@/main.js'

/**
 * Retorna os cadastros por equipe
 *
 * @param {int} cod_ibge - IBGE do município
 * @param {int} nu_ine - INE da Equipe
 * @returns {Array}
 */
export async function getCadastrosPorEquipe(cod_ibge, nu_ine) {
  try {
    const { data } = await Vue.prototype.$api.get(
      `/app/v2/acompanhamento/${cod_ibge}/equipe/${nu_ine}`
    )
    return data
  } catch (err) {
    console.log(err)
  }
}

/**
 * Retorna os cadastros por microárea
 *
 * @param {*} cod_ibge
 * @param {*} nu_ine
 * @param {*} micro_area
 *
 * @returns {Array}
 */
export async function getCadastrosPorMicroArea(cod_ibge, nu_ine, micro_area) {
  try {
    const { data } = await Vue.prototype.$api.get(
      `/app/v2/acompanhamento/${cod_ibge}/equipe/${nu_ine}/microarea/${micro_area}`
    )
    return data
  } catch (err) {
    console.log(err)
  }
}

// Buscar última atualização dos dados
/**
 * @param {int} cod_ibge - IBGE do município
 */
export async function getUltimaAtualizacao(cod_ibge) {
  try {
    const { data } = await Vue.prototype.$api.get(
      '/app/ultima-atualizacao-dos-dados/' + cod_ibge
    )
    return data
  } catch (err) {
    console.log(err)
  }
}

/**
 * Retorna o nome da cor de acordo com o valor
 * @param {Number} valor - Valor numérico
 * @returns {String}
 */
export function getCorTextoResultado(valor) {
  if (valor >= 60) {
    return 'green-color'
  } else {
    return 'red-color'
  }
}

/**
 * Retorna o nome da cor de acordo com o valor
 * @param {Number} valor - Valor numérico
 * @returns {String}
 */
export function printTableRow(item) {
  if (item.is_acompanhado == null || item.is_acompanhado == '0') {
    return 'red'
  } else {
    return 'green'
  }
}

/**
 * Gera o relatório em PDF.
 *
 * @param {Array} cadastros
 * @param {Object} selectEquipe
 * @param {String} microArea
 */
export function generatePdf(cadastros, selectEquipe, microArea) {
  let title_pdf = 'Acompanhamento'
  let titlePdfSave = utils.methods.titlePdf('Acompanhamento')

  let description_pdf =
    'Pessoas atendidas ou acompanhadas por eSF, eAP, eSB e eMulti.'
  let headers_pdf = ['NOME', 'NASCIMENTO', 'MÃE', 'CI', 'ACOMPANHAMENTO']
  var data_pdf = []
  for (let i = 0; i < cadastros.length; i++) {
    var obj = {}
    obj.no_cidadao = cadastros[i].no_cidadao
    obj.dt_nascimento =
      utils.methods.formatDate(cadastros[i].dt_nascimento) +
      `\n(${cadastros[i].idade} ${cadastros[i].idade > 1 ? 'anos' : 'ano'})`
    obj.no_mae = cadastros[i].no_mae
    obj.cadastro =
      cadastros[i].dt_ultima_ficha != null
        ? `${utils.methods.formatDate(cadastros[i].dt_ultima_ficha)}\n(${
            cadastros[i].percent_fci_completa
          }%)`
        : ''
    if (cadastros[i].dt_ultimo_acompanhamento == null) {
      obj.dt_ultimo_acompanhamento = 'Sem atendimento'
    } else {
      obj.dt_ultimo_acompanhamento =
        cadastros[i].dt_ultimo_acompanhamento != null
          ? utils.methods.formatDate(cadastros[i].dt_ultimo_acompanhamento) +
            ` (${cadastros[i].tp_ultimo_acompanhamento})`
          : ''
    }
    obj.is_acompanhado = cadastros[i].is_acompanhado
    data_pdf.push(obj)
  }

  let doc = new jsPDF({
    orientation: 'l',
    unit: 'pt',
    format: 'a4',
    ...utils.methods.encryptionPdf(),
  })
  // cria a tabela
  let table = utils.methods.createTablePdf(data_pdf)

  utils.methods
    .fileToBase64(store.state.infoMunicipio.brasao)
    .then((base64data) => {
      // Header
      let verticalPosition = utils.methods.headerPdf(
        doc,
        base64data,
        title_pdf,
        description_pdf,
        200,
        'l'
      )

      verticalPosition = utils.methods.bodyPdf(
        doc,
        [
          {
            label: 'Equipe',
            value: selectEquipe.no_equipe,
          },
          {
            label: 'CNES',
            value: selectEquipe.nu_cnes,
          },
          {
            label: 'INE',
            value: selectEquipe.nu_ine,
          },
          {
            label: 'Microárea',
            value: microArea,
          },
        ],
        verticalPosition,
        'l'
      )

      doc.autoTable({
        head: [headers_pdf],
        body: table,
        headStyles: {
          fillColor: '#ccc',
          fontSize: 6,
          textColor: '#000',
          halign: 'center',
          cellWidth: 'wrap',
        },
        bodyStyles: {
          halign: 'center',
          fontSize: 6,
        },
        theme: 'striped',
        startY: verticalPosition,
        showHead: 'firstPage',
        willDrawCell: function (data) {
          let is_acompanhado = data.row.raw[5]
          if (is_acompanhado == null || is_acompanhado == '0') {
            doc.setTextColor(194, 10, 16) // vermelho
          } else {
            doc.setTextColor(2, 99, 57) // verde
          }

          // pinta a cor da descrição das colunas de preto
          if (data.row.section === 'head') {
            doc.setTextColor(0, 0, 0)
          }
        },
      })

      utils.methods.footerPdf(doc, doc.autoTable.previous.finalY, 250, 600, 'l')

      doc.save(titlePdfSave + '.pdf')

      vue.$toast.success('PDF GERADO COM SUCESSO!', 'Sucesso:', {
        position: 'topRight',
      })
    })
    .catch((error) => {
      console.error(error)
      vue.$toast.error('ERRO AO GERAR PDF!', 'Erro:', {
        position: 'topRight',
      })
    })
}

/**
 * Resultado do município
 * @param {Object} indicadorResultado
 * @param {Array} dadosDaTabelaResultado
 * @returns {Object}
 */
export function resultadoDoMunicipio(
  indicadorResultado,
  dadosDaTabelaResultado
) {
  let numerador = 0
  let denominador = 0
  let resultado = 0

  let dadosDoMunicipio = undefined
  if (indicadorResultado !== null) {
    dadosDoMunicipio = dadosDaTabelaResultado
      .filter((item) => {
        return (
          item.ibge == store.state.cod_ibge &&
          item.indicador == '30' &&
          item.nivel == 1
        )
      })
      .sort((a, b) => {
        let [mesA, anoA] = a.mes_ano.split('/').map(Number)
        let [mesB, anoB] = b.mes_ano.split('/').map(Number)

        let dataA = new Date(anoA, mesA - 1)
        let dataB = new Date(anoB, mesB - 1)

        return dataB - dataA // Ordem decrescente
      })[0]
  }

  if (dadosDoMunicipio === undefined) {
    return {
      numerador: 0,
      denominador: 0,
      resultado: 0,
    }
  }

  if (dadosDoMunicipio.dados != null) {
    let dados = JSON.parse(dadosDoMunicipio.dados)

    numerador = dados.numerador
    denominador = dados.denominador
    resultado = dados.resultado
  }

  return {
    numerador: numerador,
    denominador: denominador,
    resultado: resultado,
  }
}

/**
 * Classificação do município
 * @param {Object} indicadorResultado
 * @param {Array} dadosDaTabelaResultado
 * @returns {Object}
 */
export function resultadoClassificacaoMunicipio(
  indicadorResultado,
  tabelaResultado
) {
  let resultado = 0
  let escore = 0
  let classificacao = '-'
  let dadosFormula = ''

  let dadosDoMunicipio = tabelaResultado
    .filter((item) => {
      return (
        item.ibge == store.state.cod_ibge &&
        item.indicador == indicadorResultado.indicador &&
        item.nivel == 1
      )
    })
    .sort((a, b) => {
      let [mesA, anoA] = a.mes_ano.split('/').map(Number)
      let [mesB, anoB] = b.mes_ano.split('/').map(Number)

      let dataA = new Date(anoA, mesA - 1)
      let dataB = new Date(anoB, mesB - 1)

      return dataB - dataA // Ordem decrescente
    })[0]

  if (dadosDoMunicipio === undefined) {
    return {
      resultado: 0,
      escore: 0,
      classificacao: '-',
      dadosFormula: '',
    }
  }

  if (indicadorResultado !== null) {
    let dados = JSON.parse(dadosDoMunicipio.dados)
    if (indicadorResultado.value == 'acompanhamento-por-cadastro-esus') {
      resultado = dados.result_cad_pec
      escore = dados.escore_pec
      classificacao = dados.classificacao_pec
      dadosFormula = {
        tipo: 'acompanhamento-por-cadastro-esus',
        parametro: dados.cad_pec,
        qtd_acomp1_0: dados.qtd_acomp1_0,
        qtd_acomp1_2: dados.qtd_acomp1_2,
        qtd_acomp1_3: dados.qtd_acomp1_3,
        qtd_acomp2_5: dados.qtd_acomp2_5,
      }
    }

    if (
      indicadorResultado.value == 'vinculo-acompanhamento-por-cadastro-esus'
    ) {
      resultado = dados.result_cad_pec
      escore = dados.escore_vinc_acomp_pec
      classificacao = dados.classificacao_pec
      dadosFormula = {
        tipo: 'vinculo-acompanhamento-por-cadastro-esus',
        escore_x: dados.escore_pec_cad,
        escore_y: dados.escore_pec_acomp,
        resultado: dados.escore_vinc_acomp_pec,
      }
    }
  }
  return {
    resultado: resultado,
    escore: escore,
    classificacao: classificacao,
    dados: dadosFormula,
  }
}

/**
 * Resultado da equipe
 * @param {Object} indicadorResultado
 * @param {Array} dadosDaTabelaResultado
 * @param {String} nuIne
 * @returns {Object}
 */
export function resultadoDaEquipe(
  indicadorResultado,
  dadosDaTabelaResultado,
  nuIne
) {
  let numerador = 0
  let denominador = 0
  let resultado = 0

  let dadosDaEquipe = undefined
  if (indicadorResultado !== null) {
    dadosDaEquipe = dadosDaTabelaResultado
      .filter((item) => {
        return item.ine == nuIne && item.indicador == '30' && item.nivel == 2
      })
      .sort((a, b) => {
        let [mesA, anoA] = a.mes_ano.split('/').map(Number)
        let [mesB, anoB] = b.mes_ano.split('/').map(Number)

        let dataA = new Date(anoA, mesA - 1)
        let dataB = new Date(anoB, mesB - 1)

        return dataB - dataA // Ordem decrescente
      })[0]
  }

  if (dadosDaEquipe === undefined) {
    return {
      numerador: 0,
      denominador: 0,
      resultado: 0,
    }
  }

  if (dadosDaEquipe.dados != null) {
    let dados = JSON.parse(dadosDaEquipe.dados)

    numerador = dados.numerador
    denominador = dados.denominador
    resultado = dados.resultado
  }

  return {
    numerador: numerador,
    denominador: denominador,
    resultado: resultado,
  }
}

/**
 * Classificação da equipe
 * @param {Object} indicadorResultado
 * @param {Array} tabelaResultado
 * @param {String} nu_ine
 * @returns {Object}
 */
export function resultadoClassificacaoEquipe(
  indicadorResultado,
  tabelaResultado,
  nu_ine
) {
  let resultado = 0
  let escore = 0
  let classificacao = '-'
  let dadosFormula = ''

  let dadosDaEquipe = tabelaResultado
    .filter((item) => {
      return (
        item.ine == nu_ine &&
        item.indicador == indicadorResultado.indicador &&
        item.nivel == 2
      )
    })
    .sort((a, b) => {
      let [mesA, anoA] = a.mes_ano.split('/').map(Number)
      let [mesB, anoB] = b.mes_ano.split('/').map(Number)

      let dataA = new Date(anoA, mesA - 1)
      let dataB = new Date(anoB, mesB - 1)

      return dataB - dataA // Ordem decrescente
    })[0]

  if (dadosDaEquipe === undefined) {
    return {
      resultado: 0,
      escore: 0,
      classificacao: '-',
      dadosFormula: '',
    }
  }
  if (indicadorResultado !== null) {
    let dados = JSON.parse(dadosDaEquipe.dados)
    if (indicadorResultado.value == 'acompanhamento-por-cadastro-esus') {
      resultado = dados.result_cad_pec
      escore = dados.escore_pec
      classificacao = dados.classificacao_pec
      dadosFormula = {
        tipo: 'acompanhamento-por-cadastro-esus',
        parametro: dados.cad_pec,
        qtd_acomp1_0: dados.qtd_acomp1_0,
        qtd_acomp1_2: dados.qtd_acomp1_2,
        qtd_acomp1_3: dados.qtd_acomp1_3,
        qtd_acomp2_5: dados.qtd_acomp2_5,
      }
    }
    if (
      indicadorResultado.value == 'acompanhamento-por-parametro-de-cadastro'
    ) {
      resultado = dados.result_param_cad
      escore = dados.escore_param
      classificacao = dados.classificacao_param
      dadosFormula = {
        tipo: 'acompanhamento-por-parametro-de-cadastro',
        parametro: dados.cad_param,
        qtd_acomp1_0: dados.qtd_acomp1_0,
        qtd_acomp1_2: dados.qtd_acomp1_2,
        qtd_acomp1_3: dados.qtd_acomp1_3,
        qtd_acomp2_5: dados.qtd_acomp2_5,
      }
    }
    if (
      indicadorResultado.value == 'vinculo-acompanhamento-por-cadastro-esus'
    ) {
      resultado = dados.result_cad_pec
      escore = dados.escore_vinc_acomp_pec
      classificacao = dados.classificacao_pec
      dadosFormula = {
        tipo: 'vinculo-acompanhamento-por-cadastro-esus',
        escore_x: dados.escore_pec_cad,
        escore_y: dados.escore_pec_acomp,
        resultado: dados.escore_vinc_acomp_pec,
      }
    }
    if (
      indicadorResultado.value ==
      'vinculo-acompanhamento-por-parametro-de-cadastro'
    ) {
      resultado = dados.result_cad_pec
      escore = dados.escore_vinc_acomp_param
      classificacao = dados.classificacao_param
      dadosFormula = {
        tipo: 'vinculo-acompanhamento-por-parametro-de-cadastro',
        escore_x: dados.escore_param_cad,
        escore_y: dados.escore_param_acomp,
        resultado: dados.escore_vinc_acomp_pec,
      }
    }
  }

  return {
    resultado: resultado,
    escore: escore,
    classificacao: classificacao,
    dados: dadosFormula,
  }
}

/**
 * Resultado da microárea
 * @param {Object} indicadorResultado
 * @param {Array} dadosDaTabelaResultado
 * @param {String} ine
 * @param {String} micro_area
 * @returns {Object}
 */
export function resultadoDaMicroArea(
  indicadorResultado,
  dadosDaTabelaResultado,
  ine,
  micro_area
) {
  let numerador = 0
  let denominador = 0
  let resultado = 0

  let dadosDaMicroArea = undefined
  if (indicadorResultado !== null) {
    dadosDaMicroArea = dadosDaTabelaResultado
      .filter((item) => {
        return (
          item.ine == ine &&
          item.micro_area == micro_area &&
          item.indicador == '30' &&
          item.nivel == 3
        )
      })
      .sort((a, b) => {
        let [mesA, anoA] = a.mes_ano.split('/').map(Number)
        let [mesB, anoB] = b.mes_ano.split('/').map(Number)

        let dataA = new Date(anoA, mesA - 1)
        let dataB = new Date(anoB, mesB - 1)

        return dataB - dataA // Ordem decrescente
      })[0]
  }

  if (dadosDaMicroArea === undefined) {
    return {
      numerador: 0,
      denominador: 0,
      resultado: 0,
    }
  }

  if (dadosDaMicroArea.dados != null) {
    let dados = JSON.parse(dadosDaMicroArea.dados)

    numerador = dados.numerador
    denominador = dados.denominador
    resultado = dados.resultado
  }

  return {
    numerador: numerador,
    denominador: denominador,
    resultado: resultado,
  }
}

/**
 * Classificação da microárea
 * @param {Object} indicadorResultado
 * @param {Array} dadosDaTabelaResultado
 * @param {String} ine
 * @param {String} micro_area
 * @returns {Object}
 */
export function resultadoClassificacaoMicroArea(
  indicadorResultado,
  tabelaResultado,
  ine,
  micro_area
) {
  let resultado = 0
  let escore = 0
  let classificacao = '-'
  let dadosFormula = ''

  let dadosDaMicroArea = tabelaResultado
    .filter((item) => {
      return (
        item.ine == ine &&
        item.micro_area == micro_area &&
        item.indicador == indicadorResultado.indicador &&
        item.nivel == 3
      )
    })
    .sort((a, b) => {
      let [mesA, anoA] = a.mes_ano.split('/').map(Number)
      let [mesB, anoB] = b.mes_ano.split('/').map(Number)

      let dataA = new Date(anoA, mesA - 1)
      let dataB = new Date(anoB, mesB - 1)

      return dataB - dataA // Ordem decrescente
    })[0]

  if (dadosDaMicroArea === undefined) {
    return {
      resultado: 0,
      escore: 0,
      classificacao: '-',
      dadosFormula: '',
    }
  }

  if (indicadorResultado !== null) {
    let dados = JSON.parse(dadosDaMicroArea.dados)
    if (indicadorResultado.value == 'acompanhamento-por-cadastro-esus') {
      resultado = dados.result_cad_pec
      escore = dados.escore_pec
      classificacao = dados.classificacao_pec
      dadosFormula = {
        tipo: 'acompanhamento-por-cadastro-esus',
        parametro: dados.cad_pec,
        qtd_acomp1_0: dados.qtd_acomp1_0,
        qtd_acomp1_2: dados.qtd_acomp1_2,
        qtd_acomp1_3: dados.qtd_acomp1_3,
        qtd_acomp2_5: dados.qtd_acomp2_5,
      }
    }
    if (
      indicadorResultado.value == 'vinculo-acompanhamento-por-cadastro-esus'
    ) {
      resultado = dados.result_cad_pec
      escore = dados.escore_vinc_acomp_pec
      classificacao = dados.classificacao_pec
      dadosFormula = {
        tipo: 'vinculo-acompanhamento-por-cadastro-esus',
        escore_x: dados.escore_pec_cad,
        escore_y: dados.escore_pec_acomp,
        resultado: dados.escore_vinc_acomp_pec,
      }
    }
  }

  return {
    resultado: resultado,
    escore: escore,
    classificacao: classificacao,
    dados: dadosFormula,
  }
}
